import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { object, string, func, bool } from 'prop-types';
import { withHandlers } from 'recompose';
import withTooltip from './withTooltip';

const styles = (theme) => ({
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

const TextComponent = ({
  resume = false,
  id,
  label,
  type,
  input = {},
  value = '',
  classes,
  onChange = () => {},
  readOnly = false,
  required = false,
  error,
}) => (
  <TextField
    key={id}
    id={id}
    label={label}
    margin="normal"
    required={required}
    onChange={input.onChange || onChange}
    className={classes.formControl}
    value={input.value || value}
    fullWidth
    disabled={readOnly}
    inputProps={{
      readOnly: resume,
    }}
    type={type}
    error={typeof error !== 'undefined'}
    helperText={typeof error !== 'undefined' && (error || 'Required')}
  />
);

TextComponent.propTypes = {
  classes: object.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  value: string,
  onChange: func.isRequired,
  readOnly: bool,
  required: bool,
  tooltip: string,
  type: string,
  error: string,
};

TextComponent.defaultProps = {
  value: '',
  onChange: () => {},
  readOnly: false,
  required: false,
  tooltip: '',
  label: '',
  type: 'text',
};

const SelectWithTooltip = withTooltip(TextComponent);
const enhance = withHandlers({
  onChange: (props) => (event) => {
    props.onChange(event.target.value);
  },
});

export default withStyles(styles)(enhance(SelectWithTooltip));



// WEBPACK FOOTER //
// ./src/view/forms/components/FormText.js